var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4199 3.00075L12.872 3.21426L12.4199 3.00075ZM12.4199 20.9993L11.9677 21.2128L12.4199 20.9993ZM2 12L1.84959 11.5232L0.337841 12L1.84959 12.4768L2 12ZM12.9126 0.786487L11.9677 2.78724L12.872 3.21426L13.8168 1.21351L12.9126 0.786487ZM11.9677 21.2128L12.9126 23.2135L13.8168 22.7865L12.872 20.7857L11.9677 21.2128ZM1.84959 12.4768C6.34098 13.8935 10.0085 17.0641 11.9677 21.2128L12.872 20.7857C10.7906 16.3783 6.90027 13.0214 2.15041 11.5232L1.84959 12.4768ZM11.9677 2.78724C10.0085 6.93595 6.34098 10.1065 1.84959 11.5232L2.15041 12.4768C6.90026 10.9786 10.7906 7.62173 12.872 3.21426L11.9677 2.78724ZM2 12.5L31 12.5V11.5L2 11.5L2 12.5Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.695afb30c9f9adfe911b711c7fbe386a.svg";
export { ForwardRef as ReactComponent };